module.exports = "/img/caret-right.svg?9f8a9a084ca8cbf8d20cb82ca0b19247";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/caret-right.svg
// module id = hJvm
// module chunks = 80